/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';
/**
 * Initial states of visual function are defined here
 */
export const initialState = {
  //
  loading: false,
  systemInformation: {},
};
/**
 * All actions related to system feature are defined here
 */
export const systemSlice = createSlice({
  name: 'feature/system',
  initialState,
  reducers: {
    getSystemInformation(state) {
      state.loading = true;
    },
    getSystemInformationSucceeded(state, action) {
      state.loading = false;
      state.systemInformation =
        action?.payload?.results?.find((filter) => filter?.key === 'maintenance') ?? {};
    },
    getSystemInformationFailed(state) {
      state.loading = false;
    },
    createSystemInformation(state) {
      state.loading = true;
    },
    createSystemInformationSucceeded(state, action) {
      state.loading = false;
      state.systemInformation = action?.payload;
    },
    createSystemInformationFailed(state) {
      state.loading = false;
    },
    updateSystemInformation(state) {
      state.loading = true;
    },
    updateSystemInformationSucceeded(state, action) {
      state.loading = false;
      state.systemInformation = action?.payload;
    },
    updateSystemInformationFailed(state) {
      state.loading = false;
    },
    syncDatabricksData(state) {
      state.loading = true;
    },
    syncDatabricksDataSucceeded(state) {
      state.loading = false;
    },
    syncDatabricksDataFailed(state) {
      state.loading = false;
    },
    syncCurrencyData(state) {
      state.loading = true;
    },
    syncCurrencyDataSucceeded(state) {
      state.loading = false;
    },
    syncCurrencyDataFailed(state) {
      state.loading = false;
    },
    syncBreakdownData(state) {
      state.loading = true;
    },
    syncBreakdownDataSucceeded(state) {
      state.loading = false;
    },
    syncBreakdownDataFailed(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: systemActions } = systemSlice;
